import React, { useContext, useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";

import InputField from "./inputField";
import PsContext from "../../../context";
import { capitalizeFirst, upperCase } from "../../../utils";

const CommunicationDetails = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);

  const [basic, setBaisc] = useState([]);
  const [marks, setMarks] = useState([]);
  const [preference, setPreference] = useState([]);

  const field = (fieldName) => {
    if (props.data && props.data[fieldName]) return props.data[fieldName];
  };

  return (
    <>
      <InputField
        label="Door No / Street"
        value={capitalizeFirst(field("street"))}
      />

      <InputField label="Place / Area" value={upperCase(field("place"))} />

      <InputField label="Village / City" value={field("city")} />

      <InputField label="Taluk" value={field("taluk")} />

      <InputField label="District" value={field("district")} />

      <InputField label="State" value={upperCase(field("state"))} />

      <InputField label="Country" value={upperCase(field("country"))} />

      <InputField label="Pincode" value={capitalizeFirst(field("pincode"))} />
    </>
  );
};

export default CommunicationDetails;
